// @ts-check
import React from "react"

/**
 * @param {import("./TableFilterButton.component.types").TableFilterButtonProps} props
 */
export const TableFilterButton = (props) => {
  const icon = props.isFiltered ? "pi-filter-fill" : "pi-filter"
  const disabled = props.disabled ? "table__column-filter-button--disabled" : ""

  return (
    <button
      className={`table__column-filter-button ${disabled}`}
      onClick={props.onClick}
      disabled={props.disabled}
    >
      <i className={`table__column-filter-icon pi ${icon}`} />
    </button>
  )
}
